import TweenMax from 'gsap';
dl.log(TweenMax);

$(function() {
    const isMobileDevice = window.navigator.userAgent.toLowerCase().includes('mobi');

    function customCursor(targets) {
        const cursor = document.querySelector('.js-cursor');

        $('body').on('mousemove', targets, function(event) {
            let target = event.target,
                x = event.clientX,
                y = event.clientY,
                label = this.dataset.cursorLabel;
            if (!cursor.classList.contains('active')) {
                cursor.classList.add('active');
            }
            //cursor.style.left = `${x}px`;
            //cursor.style.top = `${y}px`;
            TweenMax.to(cursor, .1, {
                x: event.clientX,
                y: event.clientY,
                scale: 1
            });
            if (target.classList.contains('js-cursor-link')) {
                cursor.classList.remove('active');
            }
        });

        $('body').on('mouseleave', targets, function() {
            if (cursor.classList.contains('active')) {
                cursor.classList.remove('active');
            }
        });
    }

    if (!isMobileDevice) {
        customCursor(`
        .js-location
    `);
    }
});